import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { menuData } from './data/MenuData';
import { Button } from './Button';
import './Dropdown.css';

const DropdownContainer = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  display: grid;
  top: 0;
  left: 0;

  transition-delay: ${({ isOpen }) => (isOpen ? '0s' : '1s')};
  z-index: ${({ isOpen }) => (isOpen ? '99' : '0')};
`;

const CloseIcon = styled(FaTimes)`
  color: rgb(178, 12, 78);
`;

const DropdownWrapper = styled.div`
  justify-content: center;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 2.5fr 1fr;
  }
`;

const DropdownMenu = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 60px);
  text-align: left;
    
  @media screen and (max-width: 1500px) {
    grid-template-rows: repeat(6, 50px);
  }
  @media screen and (max-width: 500px) {
    grid-template-rows: repeat(6, 60px);
  }
  @media screen and (max-width: 380px) {
    grid-template-rows: repeat(6, 60px);
  }
`;

const DropdownLink = styled(Link)`
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: left;
  text-decoration: none;
  color: #000;
  margin-left: 10px;
  font-size: 1.2rem;
  list-style: none;
  cursor: pointer;
  height: 50px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  width: 100vw;
  align-self: center;
  transition: 0.2s ease-in-out;

  &:hover {
    padding-left: 20px;
  }
  @media screen and (max-width: 1500px) {
    font-size: 1.1rem;
    height: 30px;
  }
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 500px) {
    font-size: 1rem;
    height: 50px;
  }
`;

const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  color: #000;
  margin-bottom: 25px;
  @media screen and (max-width: 600px) {
    //margin-right: 50px;
  }
`;
const NavBtnLink = styled(Link)`
  border-radius: 50px;
  background: rgb(178, 12, 78);
  white-space: nowrap;
  padding: 10px 22px;
  margin-left: -20%;
  margin-top: 35px;
  color: #010606;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transform: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2 ease-in-out;
    background: #fff;
  }
`;
const NavBtn = styled.div`
  display: flex;
  align-items: center;
  margin-right: 24px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
const Wrap = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  @media screen and (max-width: 1500px) {
    margin-top: -50px;
  }
  @media screen and (max-width: 500px) {
    margin-top: 0;
  }
`;
const One = styled.div`
  display: flex;
  align-items: flex-start;
  background: #fff;
  height: 100%;
  width: 100%;
  transition: 1s ease-in-out;
  margin-left: ${({ isOpen }) => (isOpen ? '-10px' : '0px;')};
`;
const Two = styled.div`
  background-color: #081542;
  background-color: rgba(8, 21, 66, 0.8);
  height: 100%;
  width: 100%;
  transition: 01s ease-in-out;
`;
const Div = styled.div``;

const Dropdown = ({ isOpen, toggle }) => {
  return (
    <DropdownContainer isOpen={isOpen} onClick={toggle}>
      <DropdownWrapper>
        <One className={`${isOpen ? 'one' : 'one-gone'}`}>
          <Wrap>
            <DropdownMenu>
              {menuData.map((item, index) => (
                <DropdownLink to={item.link} key={index}>
                  <Div>{item.title}</Div>
                </DropdownLink>
              ))}
            </DropdownMenu>
          </Wrap>
        </One>
        <Two className={`${isOpen ? 'two' : 'two-gone'}`}></Two>
      </DropdownWrapper>
    </DropdownContainer>
  );
};

export default Dropdown;
